module.exports = __webpack_public_path__ + "main/assets/public/rrr-50/rrr-reverse.aed6350fbec1e249.svg";